import styled from 'styled-components';

export const ConceptLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #000;
  line-height: 1.2;
  min-height: 1.2em;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;
